

    import { useI18n } from 'vue-i18n';
  import * as yup from 'yup';

  import type { CustomFieldOrderDataEntry } from '@/types';

  function getRulesString (customField: CustomFieldOrderDataEntry, required?: boolean) {
    let rules: yup.StringSchema;
    const { t } = useI18n();
    rules = yup.string();


    if (customField.customFieldData.char_limit) {
      rules = rules.matches(new RegExp(`^.{0,${customField.customFieldData.char_limit}}$`), t('validation.char_limit', { limit: customField.customFieldData.char_limit }));
    }
    if (required) {
      // cannot be empty string
      rules = rules.matches(/^(?!\s*$).+/, t('validation.required'));
      rules = rules.notOneOf([''], t('validation.required'));
      //checkbox must be 'on'
      if (customField.fieldType === 'checkbox' ){
        rules = rules.notOneOf(['off'], t('validation.required'));
      } 

      if (customField.fieldType === 'cprnumber') {
        rules = rules.matches(/^\d{6}-?\d{4}$/, t('validation.cpr'));
      }  
      else if (customField.customFieldData.only_numbers) {
        rules = rules.matches(/^\d+$/, t('validation.number'));
      }

      
    }
    if(customField.fieldlist && customField.fieldlist.values.length > 0){
      const validFieldListValues: string[] = [...customField.fieldlist.values];
      if(!required){
        validFieldListValues.push('');
        validFieldListValues.push("");
      }
      rules = rules.oneOf(validFieldListValues, t('validation.invalid_option'));
    }

    return rules;
  };
  
  function getRulesNumber (customField: CustomFieldOrderDataEntry, required?: boolean) {
    const { t } = useI18n();
    let rules: yup.NumberSchema;
    rules = yup.number();
    rules = yup.number().typeError(t('validation.number'));

    return rules;
  };

  function getRulesBoolean (customField: CustomFieldOrderDataEntry, required?: boolean) {
    const { t } = useI18n();
    let rules: yup.BooleanSchema;
    rules = yup.boolean();
    if (required) {
      rules = rules.oneOf([true], t('validation.required'));
    }

    return rules;
  };

  function getRulesSharedAll (customField: CustomFieldOrderDataEntry, rules: yup.NumberSchema | yup.StringSchema | yup.BooleanSchema, required?: boolean) {

    const { t } = useI18n();
    if (required) {
      rules = rules.required(t('validation.required'));
      rules = rules.defined(t('validation.required'));
      rules = rules.nonNullable(t('validation.required'));
    }

    return rules;
  };

  function getRulesSharedStringNumber (customField: CustomFieldOrderDataEntry, rules: yup.NumberSchema | yup.StringSchema, required?: boolean) {

    const { t } = useI18n();

    return rules;
  };

 export function getRules (customField: CustomFieldOrderDataEntry, type: string, required?: boolean){
    let rules;

    if (!customField) {
      return undefined;
    }
    if(!type){
      return undefined;
    }
    // Type rules here
    if(type == 'string'){
      rules = yup.StringSchema;
      rules = yup.string();
      rules = getRulesString(customField, required);
      rules = getRulesSharedStringNumber(customField, rules, required);
    }
    else if(type == 'number'){
      rules = yup.NumberSchema;
      rules = getRulesNumber(customField, required);
      rules = getRulesSharedStringNumber(customField, rules, required);
    }
    else if(type == 'boolean'){
      rules = yup.BooleanSchema;
      rules = getRulesBoolean(customField, required);
    }
    else {
      return undefined;
    }
    rules = getRulesSharedAll(customField, rules, required);
    // Keep this in case we need it later
    /*else {
      rules = yup.string();
      if (customField.fieldType === 'email') {
        rules = rules.email(t('validation.email'));
      }
      if (customField.fieldType === 'tel') {
        rules = rules.matches(/^\+?[0-9\s-]+$/, t('validation.phone'));
      }
      if (customField.fieldType === 'cprnumber') {
        rules = rules.matches(/^\d{6}-?\d{4}$/, t('validation.cpr'));
      }
    }*/

    return rules;
  };